<template>
  <div>
    <div v-if="nextWorkoutBlocks">
      <span v-if="workoutBlocks.length == 0" class="font-italic caption">
        No programs in progress
      </span>
      <div v-if="nextWorkoutBlocks.length > 0">
        <v-tooltip v-for="wb in nextWorkoutBlocks" :key="wb.id" bottom>
          <template v-slot:activator="{ on, attrs }">
            <span class="font-weight-bold">Upcoming: </span>
            <span v-bind="attrs" v-on="on">{{ wb.block.title }}</span>
          </template>
          <span class="block">Start date: {{ wb.startDate }} </span>
          <span class="block">End date: {{ wb.endDate }}</span>
        </v-tooltip>
      </div>
    </div>
    <div v-if="workoutBlocks && workoutBlocks.length > 0">
      <div v-for="wb in workoutBlocks" :key="wb.id">
        <active-workout-block :subscription-block="wb" />
      </div>
    </div>
  </div>
</template>

<script>
import ActiveWorkoutBlock from "@/components/dashboard/components/columns/ActiveWorkoutBlock";

export default {
  name: "ActiveWorkoutBlocks",
  components: {
    ActiveWorkoutBlock,
  },
  props: {
    workoutBlocks: {
      type: Array,
      required: false,
    },
    nextWorkoutBlocks: {
      type: Array,
      required: false,
    },
  },
};
</script>
